import(/* webpackMode: "eager" */ "/vercel/path0/src/app/xac-thuc/page.tsx");
